<template>
  <b-modal
    id="logInfoModal"
    title="Информация"
    size="xl"
    ok-only
  >
    <div v-if="logData">
      <h4>Пользователь</h4>
      <div>{{ userFullName }}</div>
      <div>Почта: {{ logData.user.email }}</div>
      <div>Организация: {{ logData.user.organization.title }}</div>
      <div>Роли: {{ userRoles }}</div>
      <h4>Дата</h4>
      <div>{{ logDateTime }}</div>
      <h4>Описание</h4>
      <div>{{ logData.description }}</div>
    </div>
  </b-modal>
</template>

<script>
import moment from 'moment'
import UserMixin from '@/components/helpers/mixins/user-mixin'

export default {
  name: 'LogInfoModal',
  props: {
    logData: {
      type: Object,
      default: null
    }
  },
  mixins: [UserMixin],
  computed: {
    userFullName() {
      return this.logData && this.logData.user
        ? `${this.logData.user.surname} ${this.logData.user.name} ${this.logData.user.midname}`.trim()
        : 'Не получено'
    },
    userRoles() {
      return this.logData && this.logData.user
        ? this.logData.user.roles.map((role) => this.$_userMixin_roleTranslate(role.title)).join(', ')
        : 'Не получено'
    },
    logDateTime() {
      return this.logData && this.logData.createdAt
        ? moment(this.logData.createdAt).add(3, 'h').format('DD.MM.YYYY HH:mm')
        : 'Не получено'
    }
  }
}
</script>

<style scoped>

</style>
